module.exports = __webpack_public_path__ + "static/media/lenovointel.42b931ee.jpg";